import styled from 'styled-components';

export const OuterWrapper = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 2rem auto;
  padding: 0 1rem; /* Always keep side gutter */

  @media (min-width: 768px) {
    padding: 0 2rem; /* Add a bit more spacing on larger screens */
  }
`;

export const YouTubeWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
  height: 0;
  overflow: hidden;
  background-color: #000;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }
`;